<div class="container">
    <div class="message">
        <div class="content">
            <h1>Not Found</h1>
            <p>The payment link you followed doesn't exist, or it expired.</p>
        </div>
    </div>
</div>
